import React from 'react';
import styled from 'styled-components';
import Link from '../../components/Link';
import Headroom from 'react-headroom';

import LanguageSwitcher from './LanguageSwitcher';
import Navigation_ from './Navigation';
import MobileNavigation_ from './MobileNavigation';
import { breakpoints } from '../../constants';

import logo from '../assets/logo.svg';

const HeaderSection = styled.section`
    height: 80px;
`;

const Logo = styled(Link)`
    background: url(${logo}) no-repeat;
    background-size: contain;
    display: block;
    width: 90px;
    height: 60px;
    margin-left: 200px;
    margin-top: 12px;
    @media (max-width: ${breakpoints.tablet}) {
        margin-left: 40px;
    }
    @media (max-width: ${breakpoints.mobile}) {
        margin-left: 20px;
    }
`;

const Spacer = styled.div`
    flex-grow: 1;
    @media (max-width: ${breakpoints.tablet}) {
        flex-grow: initial;
    }
`;

const MenuWrapper = styled.div`
    width: 100%;
    .headroom--pinned & {
        box-shadow: 0 4px 2px -2px #cac8c8;
    }
`;

const Menu = styled.div`
    height: 80px;
    width: 1600px;
    margin: 0 auto;
    top: 0;
    background-color: white;
    display: flex;
    align-items: center;
    @media (max-width: ${breakpoints.tablet}) {
        width: 100%;
    }
`;

const LanguageSwitcherWrapper = styled.div`
    margin-left: 60px;
    @media (max-width: ${breakpoints.tablet}) {
        margin-left: auto;
        margin-right: 30px;
    }
    @media (max-width: ${breakpoints.mobile}) {
        order: 1;
        margin-right: 15px;
    }
`;

const Navigation = styled(Navigation_)`
    @media (max-width: ${breakpoints.tablet}) {
        margin-left: 30px;
    }
    @media (max-width: ${breakpoints.mobile}) {
        display: none;
    }
`;

const MobileNavigation = styled(MobileNavigation_)`
    display: none;
    @media (max-width: ${breakpoints.mobile}) {
        display: initial;
        order: 2;
    }
`;

export default class Header extends React.Component {
    render() {
        const { langs } = this.props;

        return (
            <HeaderSection>
                <Headroom>
                    <MenuWrapper>
                        <Menu>
                            <Logo to="" />
                            <Spacer />
                            <Navigation />
                            <MobileNavigation />
                            <LanguageSwitcherWrapper>
                                <LanguageSwitcher langs={langs} color="black" />
                            </LanguageSwitcherWrapper>
                        </Menu>
                    </MenuWrapper>
                </Headroom>
            </HeaderSection>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/components/Header.js